import { getFontStyle } from '@diversioteam/diversio-ds'
import styled from 'styled-components'

export const ParticipationWrapper = styled.div`
    grid-area: participation-rate;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px;
    border-radius: 15px;
    border: 1.5px solid ${({ theme }) => theme.colors.primaryGray2};
    position: relative;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const Count = styled.span`
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('h2Bold')}
`

export const Description = styled.span`
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p03Regular')}

    span {
        display: block;
    }
`
